import React from "react";
import ReactDOM from "react-dom";

const ConfirmDialog = ({
  open,
  title = "Animal Luverz",
  message = "Are you sure you want to delete this product?",
  onConfirm,
  onCancel,
  yesLabel = "Yes",
  noLabel = "No",
  icon = "/logo-bg.png",
  fullscreen = false,
}) => {
  if (!open) return null;

  const dialog = (
    <div
      className={`fixed text-black inset-0 z-[99999999] flex items-center justify-center bg-black bg-opacity-60`}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={`bg-white dark:bg-[#252739] shadow-2xl text-center relative border-white dark:border-dark-border border-2 ${
          fullscreen
            ? "w-screen h-screen rounded-none flex flex-col justify-center items-center p-0"
            : "rounded-xl p-6 w-full max-w-md"
        }`}
      >
        {icon && (
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
            <img 
              src={icon} 
              alt="Icon" 
              className="h-16 w-16 sm:h-20 sm:w-20 object-contain" 
            />
          </div>
        )}

        <div
          className={`pt-12 ${
            fullscreen ? "flex flex-col items-center justify-center h-full" : ""
          }`}
        >
          <h2 className="text-black dark:text-dark-text text-xl font-bold mb-2">{title}</h2>
          <p className="text-black dark:text-dark-text mb-6">{message}</p>
          <div className="flex justify-center gap-4">
            <button
              className="bg-[#e85a59] text-white rounded-lg font-bold py-2 px-8 rounded-lg text-lg transition hover:opacity-90"
              onClick={(e) => {
                e.stopPropagation();
                onCancel();
              }}
            >
              {noLabel}
            </button>
            <button
              className="bg-[#6d2af6] text-white rounded-lg font-bold py-2 px-8 rounded-lg text-lg transition hover:opacity-90"
              onClick={(e) => {
                e.stopPropagation();
                onConfirm();
              }}
            >
              {yesLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(dialog, document.body);
};

export default React.memo(ConfirmDialog);
